import { render } from "./WritingSystem.vue?vue&type=template&id=0123a120&scoped=true"
import script from "./WritingSystem.vue?vue&type=script&lang=js"
export * from "./WritingSystem.vue?vue&type=script&lang=js"

import "./WritingSystem.vue?vue&type=style&index=0&id=0123a120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0123a120"]])

export default __exports__